import React from 'react';
import { useSelector } from 'react-redux';
import classes from './ScoreboardTabs.module.css';

const ScoreboardTabs = ({ tabs = [], onTabChange, activeTabId }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.tabsContainer}>
            <div className={classes.tabsMenu}>
                {tabs.map(tab => (
                    <div key={tab.id} className={`${classes.tabItem} ${activeTabId === tab.id ? classes.activeTab : ''}`} onClick={() => onTabChange?.(tab.id)}  >
                        <p className={classes.tabText}>
                            {tab.titleKey ? texts[tab.titleKey] : tab.title}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ScoreboardTabs;

